/**
****************************************************
***                        *******    ******    ****
***                        ******    ******    *****
***********       **************    ******    ******
***********       *************    ******    *******
***********       ************    ******    ********
***********       ***********    ******    *********
***********       **********    ******    **********
***********       *********    ******    ***********
***********       ********    ******    ************
***********       *******    ******    *************
***********       ******    ******    **************
****************************************************
* --------------------------------------------------
* Travlr UiKit: errorMessageHandler.js
* By Travlr Team
* --------------------------------------------------
*/

// const
const NAME = 'errorMessageHandler'

// Error Messages
const ErrorMessageDefault = [
  {
    ERROR_ID: 0,
    ERROR_MESSAGE: 'Error id found'
  },
  {
    ERROR_ID: 1,
    ERROR_MESSAGE: 'Config must be an object'
  },
  {
    ERROR_ID: 2,
    ERROR_MESSAGE: 'Error message not found'
  },
  {
    ERROR_ID: 3,
    ERROR_MESSAGE: 'Error message must be an collection'
  }
]

class ErrorMessageHandler {
  constructor (config) {
    if (typeof config !== 'object') throw new Error(this.getErrorMessages(1))

    if (typeof config.errorId !== 'number' || config.errorId === '') throw new Error(this.getErrorMessages(0))
    
    if (!Array.isArray(config.errorMessages)) throw new Error(this.getErrorMessages(3))

    this._config = config

    this.init()
  }

  init () {
    throw new Error(this.getErrorMessages(this._config.errorId, this._config.errorMessages))
  }

  getErrorMessages (errorId, errorMessages) {
    errorMessages = typeof errorMessages === 'undefined' ? ErrorMessageDefault : errorMessages
    return errorMessages.filter(item => item.ERROR_ID === errorId).map(item => item.ERROR_MESSAGE)
  }
}

export default ErrorMessageHandler
